const getCharLength = (str) => {
  let charLen = 0
  let numHankaku = 0
  let numZenkaku = 0
  let numLineBreak = 0

  for (let i = 0; i < str.length; i++) {
    if (str[i].match(/\r\n|\\r\\n|\r|\\r|\n|\\n/)) {
      // 改行の場合は1を加算
      charLen += 1
      numLineBreak += 1
      continue
    }
    const chr = str.charCodeAt(i)
    if ((chr >= 0x00 && chr < 0x81) ||
      (chr === 0xf8f0) ||
      (chr >= 0xff61 && chr < 0xffa0) ||
      (chr >= 0xf8f1 && chr < 0xf8f4)) {
      // 半角文字の場合は1を加算
      charLen += 1
      numHankaku += 1
    } else {
      // それ以外の文字の場合は2を加算
      charLen += 2
      numZenkaku += 1
    }
  }

  return {
    charLen: charLen,
    numHankaku: numHankaku,
    numZenkaku: numZenkaku,
    numLineBreak: numLineBreak,
  }
}

const maxHankaku = {
  params: ['max'],
  validate(val, { max } = {}) {
    const { charLen } = getCharLength(val)
    return charLen <= max
  },
  message: (fieldName, { max } = {}) => {
    const maxHankaku = max
    const maxZenkaku = parseInt(maxHankaku / 2)
    return `${fieldName}は半角${maxHankaku}文字または全角${maxZenkaku}文字以内で入力してください`
  }
}

export default maxHankaku
